import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import AddDocumentIndex from "../../../components/SidetabPages/Documents/AddDocumentIndex";

const AddDocument = () => {
  return (
    <>
      <AnnouncementBar />
      <AddDocumentIndex />
    </>
  );
};
export default AddDocument;
